/* Small interaction feedback; native forms retain behavior and validation. */
(() => {
  document.addEventListener('submit', event => {
    const form = event.target.closest('.ona-header-search');
    if (!form) return;
    const input = form.querySelector('[name="q"]');
    input.value = input.value.trim();
    if (!input.value) { event.preventDefault(); input.focus(); }
  });
  // Dismiss desktop menus when the shopper leaves the browser tab.
  window.addEventListener('blur', () => document.querySelectorAll('.ccn-desktop details[open]').forEach(item => { item.open = false; }));
})();
